export enum FileShareTypes {
  View = 2,
  Edit = 4 | View,
  Delete = 8 | View,
  Share = 16 | View,
  Full = View | Edit | Delete | Share,
}

export enum EvidenceLinkType {
  Transcription = 0,
}

export enum OpenAiTaskStatus {
  None = 0,
  Processing = 1,
  Success = 2,
  Failed = 3,
  Unprocessable = 4,
}

export enum FileTranscriptionStatus {
  None = 0,
  Requested = 1,
  Transcribed = 2,
  Failed = 3,
  Unprocessable = 4,
}
